import React from "react";
import { CategoryView } from "./CategoryView";
import {
  CrudlStatus,
  ToggleState,
  PageState,
  FeedbackState,
  ViewState,
  ValidateState,
} from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";
import * as format from "../../common/FormatFunctions";
import { ErrorScreen } from "../Common/ErrorScreen";

export class CategoryController extends React.Component {
  state = {
    pageName: "CategoryController",
    pageState: PageState.IDLE,
    sidebarWidth: "100%",

    //DISPLAY STATES
    viewState: ViewState.TABLE,
    validateState: ValidateState.NONE,
    crudlState: CrudlStatus.LIST,
    menuState: [],

    // PROPS
    viewType: "STANDARD", // e.g. InvoiceViewType.STANDARD

    // DATA TABLE
    expandedRows: null,
    tableColumns: [],
    columnOptions: [],
    settingsToggle: ToggleState.OFF,

    // DETAILS
    categoryList: null,
    originalEditedCategory: "",
    editedCategory: null,
    receivedFeedback: {
      state: FeedbackState.NONE,
      display: "Category",
      crudlStatus: CrudlStatus.LIST,
    },
    editedBusiness: {},
    editedProfile: {},
  };

  componentDidMount = async () => {
    await this.initialDataRender();
  };

  componentDidCatch = (error, info) => {
    this.props.log("This threw an error");
    this.props.log(error);
    this.props.log(info);
    //COMPONENT ISSUE CHECK IF THIS ERROR HANDLING IS CORRECT
    this.setError(false, "componentDidCatch", error);
  };

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setError = (critical, methodName, error) => {
    this.props.log.error(error.message);
    if (critical) {
      this.setCriticalError();
    } else {
      this.setStandardError();
    }
  };
  setStandardError = () => {
    //MORE CAN BE ADDED HERE AS APPROPRIATE
    this.showError("Category");
    this.setState({ pageState: PageState.IDLE });
  };
  setCriticalError = () => {
    //SET ERROR STATE OF PAGE
    this.setState({ pageState: PageState.ERROR });
  };

  setViewModel = () => {
    try {
      this.props.viewModel.updateState = this.updateState;
      this.props.viewModel.showError = this.showError;
      this.props.viewModel.showSuccess = this.showSuccess;
      this.props.viewModel.showEmpty = this.showEmpty;
    } catch (error) {
      this.setError(false, "setViewModel", error);
    }
  };

  setPageData = async () => {
    try {
      this.setState({ pageState: PageState.LOADING });

      this.menuState(CrudlStatus.LIST);

      await this.handleProps();

      // Get all available components with codeTags matrixItems returned
      await this.props.viewModel.getComponents(this.state.editedBusiness.id);
      await this.props.viewModel.getMyProfile(this.state.editedBusiness.id);

      this.setState({
        pageState: PageState.IDLE,
      });
    } catch (error) {
      this.setError(true, "setPageData", error);
    }
  };
  handleProps = async () => {
    if (format.isNotNull(this.props.viewType)) {
      await this.setState({ viewType: this.props.viewType });
    }
    if (format.isNotNull(this.props.editedBusiness)) {
      await this.setState({ editedBusiness: this.props.editedBusiness });
    }
    if (format.isNotNull(this.props.crudlState)) {
      await this.setState({ crudlState: this.props.crudlState });
    }
    if (format.isNotNull(this.props.codeTag)) {
      await this.setState({ codeTag: this.props.codeTag });
    }
  };
  showError = (display, crudlStatus, whereToView) => {
    try {
      if (whereToView === ViewState.TABLE) {
        this.props.feedback.showError(this.growl, display, crudlStatus);
      }
      if (whereToView === ViewState.CARD) {
        this.setState({
          receivedFeedback: {
            state: FeedbackState.ERROR,
            display: display,
            crudlStatus: crudlStatus,
          },
        });
      }
    } catch (error) {
      this.setError(false, "showError", error);
    }
  };

  showSuccess = (display, crudlStatus, whereToView) => {
    try {
      if (whereToView === ViewState.TABLE) {
        this.props.feedback.showSuccess(this.growl, display, crudlStatus);
      }
      if (whereToView === ViewState.CARD) {
        this.setState({
          receivedFeedback: {
            state: FeedbackState.SUCCESS,
            display: display,
            crudlStatus: crudlStatus,
          },
        });
      }
    } catch (error) {
      this.setError(false, "showSuccess", error);
    }
  };

  showEmpty = (display, whereToView) => {
    try {
      if (whereToView === ViewState.TABLE) {
        this.props.feedback.showEmpty(this.growl, display);
      }
      if (whereToView === ViewState.CARD) {
        this.setState({
          receivedFeedback: {
            state: FeedbackState.EMPTY,
            display: display,
            crudlStatus: CrudlStatus.LIST,
          },
        });
      }
    } catch (error) {
      this.setError(false, "showEmpty", error);
    }
  };

  getStateValuesAsObject = () => {
    try {
      var externalObject = {};
      externalObject.categoryBean = this.state.editedCategory;
      externalObject.viewType = this.state.viewType;

      return externalObject;
    } catch (error) {
      this.setError(false, "getStateValuesAsObject", error);
    }
  };

  updateBean = async (field, value) => {
    try {
      this.props.log.info(
        "Updating : [" + field + "] with value [" + value + "]"
      );
      await this.setState((prevState) => ({
        editedCategory: {
          // object that we want to update
          ...prevState.editedCategory, // keep all other key-value pairs
          [field]: value,
        },
      }));
    } catch (error) {
      this.setError(false, "updateBean", error);
    }
  };

  updateState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (error) {
      this.setError(false, "updateState", error);
    }
  };

  validateChanges = async () => {
    try {
      if (this.state.editedCategory === null) {
        await this.discardChanges();
      } else {
        if (
          format.isJsonEqual(
            this.state.originalEditedCategory,
            this.state.editedCategory
          )
        ) {
          await this.discardChanges();
        } else {
          this.setState({ validateState: ValidateState.CONFIRM });
        }
      }
    } catch (error) {
      this.setError(false, "validateChanges", error);
    }
  };

  discardChanges = async () => {
    try {
      this.setState({
        viewState: ViewState.TABLE,
        toggleChangesMade: false,
        crudlState: CrudlStatus.LIST,
        selectedCategory: null,
      });

      // TODO use viewType constant from AppConstants
      if (this.props.viewType !== "STANDARD") {
        if (format.isFunction(this.props.updateStateFromProps)) {
          // Toggle any relevant Views for create or update pages
          // this.props.updateStateFromProps("", false);
        }
      }

      await this.setPageData();
      this.menuState(CrudlStatus.LIST);
    } catch (error) {
      this.setError(false, "discardChanges", error);
    }
  };

  checkRequiredFields = () => {
    try {
      if (format.isNotNull(this.state.editedCategory)) {
        // ADD REQUIREDD FIELDS HERE AS APPROPRIATE
        return format.validateValues([this.state.editedCategory.name]);
      } else {
        return true;
      }
    } catch (error) {
      this.setError(false, "checkRequiredFields", error);
    }
  };

  menuState = (crudlStatus) => {
    try {
      this.setState({
        menuState: pr.getBreadcrumbMenuState(
          crudlStatus,
          "Category",
          "#/categorys"
        ),
      });
    } catch (error) {
      this.setError(false, "menuState", error);
    }
  };

  executeCrudl = async () => {
    try {
      if (format.isNotNull(this.state.crudlState)) {
        this.props.log.info("Executing " + this.state.crudlState.value);

        switch (this.state.crudlState) {
          case CrudlStatus.UPDATE:
            await this.updateCategory();
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeCrudl", error);
    }
  };

  additionalParseFunctions = async (data, crudlState) => {
    //TODO if required
    switch (crudlState) {
      case CrudlStatus.CREATE:
        break;
      case CrudlStatus.UPDATE || CrudlStatus.VIEW:
        break;
      case CrudlStatus.DELETE:
        break;
      default:
        break;
    }
    this.props.log.info(data);
    return data;
  };

  updateCategory = async (stayOnPage) => {
    this.setState({ pageState: PageState.LOADING });

    let updateArray = [];
    let createArray = [];
    let deleteArray = [];

    let componentArray = format.deepCopy(this.state.componentList);
    let categoryArray = format.deepCopy(this.state.categoryList);
    let componentIdList = [];

    console.log("componentArray", componentArray);
    console.log("categoryArray", categoryArray);

    componentArray.forEach((e) => {
      categoryArray.forEach((f) => {
        if (e.id === f.id) {
          if (e.checked === f.checked) {
            if (e.score !== f.score || e.details !== f.details) {
              //update matrixItem
              updateArray.push(f);
            }
          } else {
            if (f.checked === true) {
              //create matrixItem
              createArray.push(f);
            } else {
              //delete matrixItem
              deleteArray.push(f);
            }
          }
        }
      });
    });

    categoryArray.forEach((e) => {
      if (
        format.isNotNull(e.selectedOnCreate) &&
        e.selectedOnCreate !== false
      ) {
        componentIdList.push(e.id);
      }
    });

    console.log("createArray", createArray);
    console.log("updateArray", updateArray);
    console.log("deleteArray", deleteArray);

    if (updateArray.length) {
      await this.updateMatrixItem(updateArray);
    }
    if (createArray.length) {
      await this.createMatrixItem(createArray);
    }
    if (deleteArray.length) {
      await this.deleteMatrixItem(deleteArray);
    }

    await this.updateProfileComponentList(componentIdList);

    // await this.props.viewModel.getComponents();

    this.setState({ pageState: PageState.IDLE });
  };

  createMatrixItem = async (array) => {
    let matrixItemRequest = {};
    let matrixItemArray = [];

    if (format.isNotNull(array)) {
      array.forEach((e) => {
        matrixItemArray.push({
          componentId: e.id,
          score: e.score,
          otherComponent: e.details,
        });
      });
    }

    matrixItemRequest.matrixItemList = matrixItemArray;

    let response = await this.props.viewModel.createMatrixItem(
      matrixItemRequest,
      this.state.codeTag
    );
    return response;
  };

  updateMatrixItem = async (array) => {
    let matrixItemRequest = {};
    let matrixItemArray = [];

    if (format.isNotNull(array)) {
      array.forEach((e) => {
        matrixItemArray.push({
          componentId: e.id,
          id: e.matrixItemList[0].id,
          lastUpdatedDateTime: e.matrixItemList[0].lastUpdatedDateTime,
          score: e.score,
          otherComponent: e.details,
        });
      });
    }

    matrixItemRequest.matrixItemList = matrixItemArray;

    let response = await this.props.viewModel.updateMatrixItem(
      matrixItemRequest,
      this.state.codeTag
    );
    return response;
  };

  deleteMatrixItem = async (array) => {
    let matrixItemRequest = {};
    let matrixItemArray = [];

    if (format.isNotNull(array)) {
      array.forEach((e) => {
        matrixItemArray.push({
          componentId: e.id,
          id: e.matrixItemList[0].id,
          lastUpdatedDateTime: e.matrixItemList[0].lastUpdatedDateTime,
        });
      });
    }

    matrixItemRequest.matrixItemList = matrixItemArray;

    let response = await this.props.viewModel.deleteMatrixItem(
      matrixItemRequest,
      this.state.codeTag
    );
    return response;
  };

  updateProfileComponentList = async (componentIdList) => {
    let profileRequest = format.deepCopy(this.state.editedProfile);

    profileRequest.componentList = componentIdList;

    delete profileRequest.profileItemList;
    delete profileRequest.companyDetails;

    let response = await this.props.viewModel.updateProfile(profileRequest);
    return response;
  };

  changeCategoriesState = (key, value) => {
    let categoryList = format.deepCopy(this.state.categoryList);

    categoryList.forEach((e) => {
      if (key === e.name + " Score") {
        if (format.isNotNull(e.score) && value === e.score) {
          e.score = null;
          e.selectedOnCreate = null;
          if (e.checked === true) {
            e.checked = false;
          } else {
            e.checked = null;
          }
        } else {
          e.score = value;
          e.selectedOnCreate = value;
          e.checked = true;
        }
      }
      if (key === e.name + " Details") {
        e.details = value;
      }
    });

    this.setState({
      categoryList: categoryList,
    });
  };

  render() {
    return (
      <React.Fragment>
        <pr.Messages
          style={{ textAlign: "left" }}
          ref={(el) => (this.growl = el)}
        />

        {this.state.pageState === PageState.ERROR && (
          <ErrorScreen
            loading={this.state.pageState === PageState.LOADING}
            refresh={this.setPageData}
          />
        )}

        {this.state.pageState !== PageState.ERROR && (
          <CategoryView
            //STATE + HELPER VALUES
            viewState={this.state.viewState}
            validateState={this.state.validateState}
            crudlState={this.state.crudlState}
            menuState={this.state.menuState}
            loading={this.state.pageState === PageState.LOADING}
            updateState={this.updateState}
            refresh={this.setPageData}
            feedback={this.props.feedback}
            receivedFeedback={this.state.receivedFeedback}
            //CARD SPECIFIC PROPS
            viewType={this.state.viewType}
            editedObject={this.state.editedCategory}
            categoryTypeOptions={this.state.categoryTypeOptions}
            updateEdited={this.updateBean}
            validateChanges={this.validateChanges}
            discardChanges={this.discardChanges}
            checkRequiredFields={this.checkRequiredFields}
            crudlExecute={this.executeCrudl}
            sidebarWidth={this.state.sidebarWidth}
            //
            changeCategoriesState={this.changeCategoriesState}
            // categoryList={this.state.categoryList}
            componentList={this.state.categoryList}
            editedBusiness={this.state.editedBusiness}
          />
        )}
      </React.Fragment>
    );
  }
}
